document.addEventListener("DOMContentLoaded", () => {
  // const deferredElClicks = document.querySelectorAll('.deferred-media__poster');
  // deferredElClicks.forEach(btn => btn.click());
  // const startedVideos = new WeakSet();
  // let observer = new MutationObserver(() => {
  //   const videos = document.querySelectorAll('.deferred-media video');
  //   videos.forEach(video => {
  //     if (!startedVideos.has(video)) {
  //       try {
  //         video.click();
  //       } catch(e) {}

  //       startedVideos.add(video);
  //     }
  //   });
  // });
  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });

  if (typeof Swiper === "undefined") return;
  document.querySelectorAll(".swiper").forEach((swiperEl) => {
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },

      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },

      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        576: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 5 },
      },
    });
  });

// custom popup 
const getPopupFromHash = () => {
  if (!window.location.hash) return null;
  return document.getElementById(window.location.hash.replace('#', ''));
};
let customPopup = getPopupFromHash();
const openCustomPopup = () => {
  if (!customPopup) return;
  customPopup.classList.add('active');
  customPopup.hidden = false;
};
const closeCustomPopup = () => {
  if (!customPopup) return;
  customPopup.classList.remove('active');
  customPopup.hidden = true;
  history.replaceState(null, '', window.location.pathname);
};
/* initial load */
if (customPopup) {
  openCustomPopup();
}
/* hash change */
window.addEventListener('hashchange', () => {
  const nextPopup = getPopupFromHash();
  if (customPopup && customPopup !== nextPopup) {
    closeCustomPopup();
  }
  customPopup = nextPopup;
  if (customPopup) {
    openCustomPopup();
  }
});
/* overlay / close click */
document.addEventListener('click', (e) => {
  if (!customPopup) return;
  if (
    e.target === customPopup ||
    e.target.classList.contains('popup-close')
  ) {
    closeCustomPopup();
  }
});
/* succes message for custom popup */
  // const customSuccessMarker = document.querySelector('.js-popup-success');
  // if (!customSuccessMarker) return;
  // const customPopupId = customSuccessMarker.dataset.customPopupId;
  // if (!customPopupId) return;
  // const customTrigger = document.querySelector(`a[href="#popup-${customPopupId}"]`);
  // if (!customTrigger) return;
  // const customSuccess = document.createElement('span');
  // customSuccess.className = 'popup-customTrigger-success';
  // customSuccess.textContent = '✔ Mesaj trimis';
  // customTrigger.insertAdjacentElement('afterend', customSuccess);
  // /* close popup */
  // const ourCustomPopup = document.getElementById(`popup-${customPopupId}`);
  // if (ourCustomPopup) {
  //   ourCustomPopup.classList.remove('active');
  //   ourCustomPopup.hidden = true;
  // }
  // history.replaceState(null, '', window.location.pathname);


  // Precomanda logic
function DCgetForms() {
  return document.querySelectorAll('product-form');
}
function DCgetVariantData(form) {
  if (!form) return null;
  const input = form.querySelector('input[name="id"]');
  if (!input) return null;
  const variantId = input.value;
  const variantData = window.productVariants?.find(v => v.id == variantId);
  if (!variantData) return null;
  return { form, input, variantId, variantData };
}
function DCformatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, window.theme?.moneyFormat);
  }
  return (cents / 100).toFixed(2) + ' ' + (window.Shopify?.currency?.active || '');
}
// preorder button
function DCupdatePreorderButton() {
  const forms = document.querySelectorAll('product-form');
  if (!forms.length) return;
  forms.forEach((form) => {
    const data = DCgetVariantData(form);
    if (!data) return;
    const { variantData } = data;
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;
    if (!variantData.available) {
      button.disabled = false;
      button.textContent = 'Precomandă';
      button.dataset.preorder = 'true';
    } else {
      button.dataset.preorder = 'false';
    }
  });
}
// variant field
function DCfillVariantField(form) {
  const data = DCgetVariantData(form);
  if (!data) return;
  const { variantId, variantData } = data;
  const field = document.getElementById('variant-field');
  if (!field) return;
  field.value = `${variantData.name} (ID: ${variantId})`;
}
const DCpopup = document.getElementById('popup-comanda');
function DCupdateDescription(form) {
  const data = DCgetVariantData(form);
  if (!data) return;
  const { variantData } = data;
  const desc = document.querySelector('#popup-comanda .description');
  if (!desc) return;
  const priceFormatted = DCformatMoney(variantData.price);
  desc.textContent = `${variantData.name} — ${priceFormatted}`;
}
function DCopenPopup(form) {
  if (!DCpopup) return;
  DCupdateDescription(form);
  DCpopup.removeAttribute('hidden');
  DCpopup.classList.add('active');
}
function DCclosePopup() {
  if (!DCpopup) return;
  DCpopup.setAttribute('hidden', true);
  DCpopup.classList.remove('active');
  history.replaceState(null, '', window.location.pathname);
}
// hash logic
if (window.location.hash === '#popup-comanda') {
  DCopenPopup();
}
window.addEventListener('hashchange', () => {
  window.location.hash === '#popup-comanda' ? DCopenPopup() : DCclosePopup();
});
// variant change
document.addEventListener('change', (e) => {
  if (e.target.matches('input[name="id"], select[name="id"]')) {
    setTimeout(DCupdatePreorderButton, 100);
  }
});
document.addEventListener('submit', (e) => {
  const form = e.target.closest('product-form');
  if (!form) return;
  const button = form.querySelector('button[type="submit"]');
  if (!button) return;
  if (button.dataset.preorder === 'true') {
    e.preventDefault();
    e.stopPropagation();
    DCfillVariantField(form);
    DCopenPopup(form);
  }
});
if (DCpopup) {
  DCpopup.addEventListener('click', (e) => {
    if (e.target === DCpopup || e.target.classList.contains('popup-close')) {
      DCclosePopup();
    }
  });
}
DCupdatePreorderButton();
// end Precomanda logic


    let anpcLinks = document.querySelectorAll('a[href="https://anpc.ro/"]');
    anpcLinks.forEach((anpcLink) => {
        anpcLink.setAttribute("rel", "nofollow");
        anpcLink.setAttribute("target", "_blank");
    });


  /* Lightbox */
  const galleryLightbox = document.querySelector(".custom-gallery");
  if (!galleryLightbox || !lightbox) return;

  if (galleryLightbox) {

    const lightbox = document.getElementById("lightbox");
    const lightboxImg = document.getElementById("lightbox-img");
    const btnClose = lightbox.querySelector(".lightbox-close");
    const btnPrev = lightbox.querySelector(".lightbox-prev");
    const btnNext = lightbox.querySelector(".lightbox-next");

    let currentIndex = 0;
    const images = Array.from(galleryLightbox.querySelectorAll("img")).map(img => img.src);

    function openLightbox(index) {
      currentIndex = index;
      lightbox.style.display = "block";
      lightboxImg.src = images[currentIndex];
    }

    function closeLightbox() {
      lightbox.style.display = "none";
    }

    function changeImage(direction) {
      currentIndex = (currentIndex + direction + images.length) % images.length;
      lightboxImg.src = images[currentIndex];
    }

    // События для картинок
    galleryLightbox.querySelectorAll("img").forEach((img, index) => {
      img.addEventListener("click", () => openLightbox(index));
    });
    // События для кнопок
    btnClose.addEventListener("click", closeLightbox);
    btnPrev.addEventListener("click", (e) => {
      e.stopPropagation();
      changeImage(-1);
    });
    btnNext.addEventListener("click", (e) => {
      e.stopPropagation();
      changeImage(1);
    });
    // Закрытие по клику на фон
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) closeLightbox();
    });
    // Управление клавиатурой
    document.addEventListener("keydown", (e) => {
      if (lightbox.style.display === "block") {
        if (e.key === "Escape") closeLightbox();
        if (e.key === "ArrowLeft") changeImage(-1);
        if (e.key === "ArrowRight") changeImage(1);
      }
    });
  }

});